import React from 'react';
import { CustomSelect } from 'components';
import { CustomSelectProps } from 'components/CustomSelect/CustomSelect.props';
import useCompanyListOptions from 'pages/Waterfall/components/CompanyList/useCompanyListOptions';

const CompanyList = (props: CustomSelectProps) => {
  const { cell, onCommit, onRevert } = props;

  const { options } = useCompanyListOptions()

  return (
    <CustomSelect
      id="company-list"
      options={options}
      value={cell.value as string}
      onCommit={onCommit}
      onRevert={onRevert}
      onEmptyValue=""
      menuPlacement="bottom"
      usePortal
    />)
}

export default CompanyList;